import { EventDispatcher } from "@ravalmatic/catafractum-utils";
import { GameConstants } from "./GameConstants";
import { GameData, GameEventType, MatchState } from "./Types";

export class GameVars {

    public static gameData: GameData;
    public static matchState: MatchState;
    public static eventsDispatcher: EventDispatcher<GameEventType>;
    public static currentScene: Phaser.Scene;
    public static isLandscape: boolean;
    public static gameWidth: number;
    public static gameHeight: number;
    public static scaleY: number;
    public static tutorialMode: boolean;
  
    public static createMatchState(): MatchState {

        return {
            roundNumber: 1,
            hands: [],
            northSouth: { totalPoints: 0, gamePoints: 0, gamesWon: 0, vulnerable: false },
            eastWest: { totalPoints: 0, gamePoints: 0, gamesWon: 0, vulnerable: false },
            rubber: {
                games: [],
                currentGame: { handCount: 0, points: { northSouth: 0, eastWest: 0 } }
            }
        };
    }

    public static inferIsLandscapeLayout(): boolean {

        const userAgent = navigator.userAgent || "";
        const platform = navigator.platform || "";
        const isTouchMac = /MacIntel/.test(platform) && navigator.maxTouchPoints > 2;
        const hasTouchPoints = typeof navigator.maxTouchPoints === "number" && navigator.maxTouchPoints > 0;
        const isCoarsePointer = window.matchMedia?.("(pointer: coarse)").matches ?? false;
        const hasFinePointer = (window.matchMedia?.("(pointer: fine)").matches || window.matchMedia?.("(any-pointer: fine)").matches) ?? false;
        const canHover = (window.matchMedia?.("(hover: hover)").matches || window.matchMedia?.("(any-hover: hover)").matches) ?? false;
        const isMobileUserAgent = /Android|iPhone|iPad|iPod|Windows Phone|Mobile/i.test(userAgent);
        const isDesktopPlatform = /Win32|Win64|Windows|MacIntel|MacPPC|Mac68K|Linux x86_64|Linux armv/i.test(platform);

        if (isDesktopPlatform && !isMobileUserAgent && (hasFinePointer || canHover)) {
            return true;
        }

        return !hasTouchPoints && !isTouchMac && !isCoarsePointer;
    }

    public static setLayout(isLandscape: boolean): void {

        GameVars.isLandscape = isLandscape;
        GameVars.gameWidth = isLandscape ? GameConstants.GAME_WIDTH_LANDSCAPE : GameConstants.GAME_WIDTH_PORTRAIT;
        GameVars.gameHeight = isLandscape ? GameConstants.GAME_HEIGHT_LANDSCAPE : GameConstants.GAME_HEIGHT_PORTRAIT;
        GameVars.scaleY = 1;
    }

    public static getWorldPosition(object: Phaser.GameObjects.GameObject): { x: number, y: number } {
        
        if (!("x" in object) || !("y" in object)) {
            throw new Error("The object doesn't have the position property (x, y).");
        }
    
        let x = (object as any).x; // Type assertion
        let y = (object as any).y;
        let parent = object.parentContainer;
        
        while (parent) {

            // apply scale
            x *= parent.scaleX;
            y *= parent.scaleY;
    
            // apply rotation
            const cos = Math.cos(parent.rotation);
            const sin = Math.sin(parent.rotation);
            const rotatedX = x * cos - y * sin;
            const rotatedY = x * sin + y * cos;
    
            // apply position
            x = rotatedX + parent.x;
            y = rotatedY + parent.y;
    
            parent = parent.parentContainer;
        }
    
        return { x, y };
    }

    public static formatTime(timeInSeconds: number): string {

        if (isNaN(timeInSeconds) || timeInSeconds > 24 * 3600) {
            return "0:00";
        }

        const hours = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor((timeInSeconds % 3600) / 60);
        const paddedMinutes = ("0" + minutes).slice(-2);
        const paddedSeconds = ("0" + Math.floor(timeInSeconds % 60)).slice(-2);

        if (hours > 0) {
            return `${hours}:${paddedMinutes}`;
        }

        return `${minutes}:${paddedSeconds}`;
    }

    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}
